const listNamesConfig = {
  entityItemsNamePlural: "Campaigns",
  entityItemName: "Campaign",
  areaAccessName: "Campaigns"
};

export default listNamesConfig;